// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorMessage--Aybpd {
  color: red;
}

.messageBoxWrapper--JhfFn {
  pointer-events: none;
}

[dir=ltr] .messageBoxWrapper--JhfFn {
  animation: hide--kis46 0.5s ease-out 2s 1 normal forwards;
}

[dir=rtl] .messageBoxWrapper--JhfFn {
  animation: hide--kis46 0.5s ease-out 2s 1 normal forwards;
}

@keyframes hide--kis46 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/MessageBox/styles.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EAEE,oBAAoB;AACtB;;AAHA;EACE,yDAAkD;AAEpD;;AAHA;EACE,yDAAkD;AAEpD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".errorMessage {\n  color: red;\n}\n\n.messageBoxWrapper {\n  animation: hide 0.5s ease-out 2s 1 normal forwards;\n  pointer-events: none;\n}\n\n@keyframes hide {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `errorMessage--Aybpd`,
	"messageBoxWrapper": `messageBoxWrapper--JhfFn`,
	"hide": `hide--kis46`
};
export default ___CSS_LOADER_EXPORT___;
